export default "__VITE_ASSET__DcxoVkfH__"